import {
  Create,
  required,
  SimpleForm,
  TextInput,
  TranslatableInputs,
} from 'react-admin';
import { locales } from '../../i18n/languges';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { FieldValues } from 'react-hook-form';

const schema = yup.object().shape({
  title: yup
    .object()
    .shape({
      en: yup.string().required(),
    })
    .required(),
});

const resolver = yupResolver<FieldValues>(schema);

export const DestinationPageCreate = () => {
  return (
    <Create resource="destinationpages" redirect="/destinationpages">
      <SimpleForm resolver={resolver}>
        <TranslatableInputs locales={locales} sx={{ marginBottom: '2rem' }}>
          <TextInput source="title" label="resources.destinationpages.fields.title" validate={[required()]} />
        </TranslatableInputs>
      </SimpleForm>
    </Create>
  );
};
